const evalViaInlineScript = (code: string): any => {
    const key = `__druid_fn_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    const script = document.createElement('script');
    script.textContent = `window["${key}"] = (${code});`;
    document.head.appendChild(script);   // executes synchronously
    document.head.removeChild(script);   // clean up
    const fn = (window as any)[key];
    delete (window as any)[key];
    return fn;
};

export { evalViaInlineScript };

export const babelTransformObject = async (toTransform: any, withDecorate?: boolean): Promise<any> => {
    if (toTransform && typeof toTransform === "string") {
        try {
          const webChatEventHandlerFunc = evalViaInlineScript(toTransform);
          if(withDecorate) {
            return  (...args) => {
                try {
                  return webChatEventHandlerFunc(...args);
                } catch (ex) {
                  console.error(`Failed to execute babel transformed object: with exception: ${ex}`);
                }
              };
          } else {
              return webChatEventHandlerFunc;
          }
         
        } catch (ex) {
          console.error(`Failed to babel transform object: with exception: ${ex}`);
          Promise.reject();
        }
    } else {
        return toTransform;
    }
    
}